import { ELEMENTS } from './constants';

export function daysSinceLastEntry(entries) {
  if (!entries.length) return "—";
  const last = entries[0].date;
  const diff = (new Date().getTime() - new Date(last).getTime()) / (1000*60*60*24);
  return Math.floor(diff);
}

export function lastNEntries(entries, n = 14) { 
  return entries.slice(0, n); 
}

export function extractMoodKeywords(text) {
  if (!text) return [];
  const t = text.toLowerCase();
  const keywords = [];
  if (t.includes("snack") || t.includes("hungr") || t.includes("eat")) keywords.push("snacks");
  if (t.includes("calm") || t.includes("still")) keywords.push("calm");
  if (t.includes("fog") || t.includes("uncertain") || t.includes("confus")) keywords.push("fog");
  if (t.includes("sun") || t.includes("bright")) keywords.push("sunny");
  if (t.includes("chop") || t.includes("choppy") || t.includes("waves")) keywords.push("choppy");
  if (t.includes("music") || t.includes("song")) keywords.push("music");
  if (t.includes("love") || t.includes("partner") || t.includes("relationship")) keywords.push("partner");
  return Array.from(new Set(keywords));
}

export function landscapeForEntry(entry) {
  const map = { earth: [], water: [], air: [], fire: [] };
  ELEMENTS.forEach((el) => {
    const txt = entry?.values?.[el.key]?.text || "";
    const kws = extractMoodKeywords(txt);
    map[el.key] = kws;
  });
  return map;
}
